import axios from 'axios';

import httpUtils from '@/utils/http-utils';

const CMSApiReq = httpUtils.createRequester({
  baseUrl: process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/",
  requesterType: 'CMS_WEB_SERVICE',
});


export default {
  fetchCMSCarousels(params){
    const portausContextToken = localStorage.getItem('portaus-context');
    const accessToken = localStorage.getItem('access-token');
    return CMSApiReq.get('/carousels', {
      params,
      headers: {
        'x-portaus-context': portausContextToken,
        'authorization': accessToken,
      }
    })
      .then(res => res && res.data);

  },
  deleteCMSCarousel(id) {
    const portausContextToken = localStorage.getItem('portaus-context');
    const accessToken = localStorage.getItem('access-token');
    return CMSApiReq.delete(`/carousels/${id}`, {
      headers: {
        'x-portaus-context': portausContextToken,
        'authorization': accessToken,
      }
    })
      .then(res => res && res.data);
  },
  saveCarousel(carousel){
    const portausContextToken = localStorage.getItem('portaus-context')
    const accessToken = localStorage.getItem('access-token');
    return CMSApiReq.post('/carousels', carousel, {
      headers: {
        'x-portaus-context': portausContextToken,
        'authorization': accessToken,
      }
    })
    .then(res => res && res.data);
  },
  updateCarousel(id, carousel){
    const portausContextToken = localStorage.getItem('portaus-context')
    const accessToken = localStorage.getItem('access-token');
    return CMSApiReq.put(`/carousels/${id}`, carousel, {
      headers: {
        'x-portaus-context': portausContextToken,
        'authorization': accessToken,
      }
    })
    .then(res => res && res.data);
  },
  fetchCMSBlogs(params, locale){
    return CMSApiReq.get('/blogs', {
      params,
      headers: {
        'accept-language': locale,
      }
    })
      .then(res => res && res.data);
  },
  fetchCMSBlogTypes (locale) {
    return CMSApiReq.get('/blog-types', {
      headers: {
        'accept-language': locale,
      }
    })
      .then(res => res && res.data);
  },
  saveBlog(blog){
    return CMSApiReq.post('/blogs', blog)
      .then(res => res && res.data);
  },
  updateBlog(blogId, blog){
    return CMSApiReq.put('/blogs/'+blogId, blog)
      .then(res => res && res.data);
  },
  getCMSBlog(blogId){
    return CMSApiReq.get('/blogs/'+blogId)
      .then(res => res && res.data);
  },
  deleteBlog (blogId) {
    return CMSApiReq.delete('/blogs/'+blogId)
      .then(res => res && res.data);
  },
  fetchCMSAttributes(params){
    return CMSApiReq.get('/attributes', {
      params
    })
      .then(res => res && res.data);
  },
  fetchCMSProviders(params){
    return CMSApiReq.get('/providers', {
      params
    })
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/providers", {params})
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  getCMSProvider(providerId){
    return CMSApiReq.get('/providers/'+providerId)
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/providers/"+providerId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  fetchCMSGalleries(params){
    return CMSApiReq.get('/galeries', {
      params
    })
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/galeries", {params})
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  getCMSGalleries(galeryId){
    return CMSApiReq.get('/galeries/'+galeryId)
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/galeries/"+galeryId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  fetchCMSGalleryTypes(){
    return CMSApiReq.get('/galery-types')
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/galery-types")
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveGallery(gallery){
    return CMSApiReq.post('/galeries', gallery)
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/galeries", gallery)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteGalery(id){
    return CMSApiReq.delete('/galeries/'+id)
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/galeries/"+id)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveProvider(provider){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.post('/providers', provider, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/providers", provider)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateProvider(providerId, provider){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.put('/providers/'+providerId, provider, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/providers/"+providerId, provider)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteProvider(providerId){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.delete('/providers/'+providerId, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/providers/"+providerId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  fetchRegions(params){
    return CMSApiReq.get('/regions', {params})
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/regions", {params})
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  fetchCities(params){
    return CMSApiReq.get('/cities', {params})
      .then(res => res && res.data);
  },
  getRegion(regionId){
    return CMSApiReq.get('/regions/' + regionId)
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/regions/"+regionId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  getCity(cityId){
    return CMSApiReq.get('/cities/' + cityId)
      .then(res => res && res.data);
  },
  fetchProviderTypes(){
    return CMSApiReq.get('/provider-types')
    .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/provider-types")
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveRegion(region){
    return CMSApiReq.post('/regions', region)
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/regions", region)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveCity(city){
    return CMSApiReq.post('/cities', city)
      .then(res => res && res.data);
  },
  fetchProductTypes(){
    return CMSApiReq.get('/product-types')
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-types")
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveProductTypes(productType){
    return CMSApiReq.post('/product-types', productType)
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-types", productType)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateProductTypes(productTypeId, productType){
    return CMSApiReq.put('/product-types/'+productTypeId, productType)
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-types/"+productTypeId, productType)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteProductTypes(productTypeId){
    return CMSApiReq.delete('/product-types/'+productTypeId)
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-types/"+productTypeId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  fetchProductSpecificTypes(params){
    return CMSApiReq.get('/specific-product-types', {params})
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/specific-product-types", {params})
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveProductSpecificTypes(specificProductType){
    return CMSApiReq.post('/specific-product-types', specificProductType)
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/specific-product-types", specificProductType)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateProductSpecificTypes(specificProductTypeId,specificProductType){
    return CMSApiReq.put('/specific-product-types/'+specificProductTypeId, specificProductType)
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/specific-product-types/"+specificProductTypeId, specificProductType)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteProductSpecificTypes(specificProductTypeId){
    return CMSApiReq.delete('/specific-product-types/'+specificProductTypeId)
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/specific-product-types/"+specificProductTypeId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  getProductItemPropertyLabels(productTypeId){
    let params = {
      productTypeId
    };
    return CMSApiReq.get('/product-item-property-labels', {params})
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-item-property-labels", {params})
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateProductItemPropertyLabelsSequence(postData){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.put('/product-item-property-labels/sequences', postData, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-item-property-labels/sequences", postData)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveProductItemPropertyLabels(attribute){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.post('/product-item-property-labels', attribute, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-item-property-labels", attribute)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateProductItemPropertyLabels(id, attribute){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.put('/product-item-property-labels/'+id, attribute, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-item-property-labels/"+id, attribute)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteProductItemPropertyLabels(attributeId, force=false){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.delete('/product-item-property-labels/'+attributeId, { headers: { 'x-force-delete': force, 'x-portaus-context': portausContextToken }})
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-item-property-labels/"+attributeId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  fetchCMSProductItems(params){
    return CMSApiReq.get('/product-items', {params})
      .then(res => res && res.data);
  },
  fetchCMSProducts(params){
    return CMSApiReq.get('/products/elastic', {params})
      .then(res => res && res.data);
  },
  saveProduct(product){
    return CMSApiReq.post('/product-definitions', product)
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/products", product)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateProduct(productId, product){
    return CMSApiReq.put('/product-definitions/'+productId, product)
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/products/"+productId, product)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteProduct(productId){
    return CMSApiReq.delete('/product-definitions/'+productId)
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/products/"+productId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  getCMSProduct(productId){
    return CMSApiReq.get('/products/'+productId)
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/products/"+productId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  saveCMSProductItem(productItem){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.post('/product-items', productItem, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.post(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-items", productItem)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  updateCMSProductItem(productItemId, productItem){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.put('/product-items/'+productItemId, productItem, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.put(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-items/"+productItemId, productItem)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  getCMSProductItem(productItemId){
    return CMSApiReq.get('/product-items/'+productItemId)
      .then(res => res && res.data);
    // return axios.get(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-items/"+productItemId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
  deleteCMSProductItem(productItemId){
    const portausContextToken = localStorage.getItem('portaus-context')
    return CMSApiReq.delete('/product-items/'+productItemId, {
      headers: {
        'x-portaus-context': portausContextToken,
      }
    })
      .then(res => res && res.data);
    // return axios.delete(process.env.VUE_APP_CMS_WEB_SERVICE_API_URL+":"+process.env.VUE_APP_CMS_WEB_SERVICE_API_PORT+"/api/latest/admin/product-items/"+productItemId)
    //   .then(results=>{
    //     return results.data;
    //   })
  },
}
